import { render, staticRenderFns } from "./Public_profile.vue?vue&type=template&id=1fcce1bc&scoped=true&"
import script from "./Public_profile.vue?vue&type=script&lang=js&"
export * from "./Public_profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcce1bc",
  null
  
)

export default component.exports